import Image from 'next/image'
import Date from './date'

interface AvatarProps {
  author: Blog.Author
  dimensions?: string
  dateString?: string
}

const Avatar: React.FC<AvatarProps> = ({ author, dateString }) => {
  const name = author ?
    author.firstName && author.lastName ?
      `${author.firstName} ${author.lastName}` :
      author.name :
    null

  return author ? (
    <div className='flex items-center'>
      <Image
        alt={name || ''}
        className='h-9 w-9 rounded-full object-cover sm:h-10 sm:w-10'
        height={author.avatar.height}
        src={author.avatar.url}
        width={author.avatar.width}
      />

      <div className='ml-3'>
        <p className='text-sm font-medium text-gray-800'>{name}</p>
        {dateString && (
          <div className='flex space-x-1 text-sm text-gray-500'>
            <Date dateString={dateString} />
          </div>
        )}
      </div>
    </div>
  ) : null
}

export default Avatar
